export const BOOKING_QUOTES_ROUTE_PREFIX: string = '/dashboard/booking-quotes';

interface BookingQuotesRoutes {
  details: {
    getUrl: (id: string, tab?: string) => string;
    path: string;
    relativePath: string;
  };
  index: {
    getUrl: (scopeSlug?: string) => string;
    path: string;
    relativePath: string;
  };
}

const bookingQuotesRoutes: BookingQuotesRoutes = {
  details: {
    path: `${BOOKING_QUOTES_ROUTE_PREFIX}/details/:id/:tab?`,
    getUrl: (id: string, tab?: string): string => {
      const url: string = `${BOOKING_QUOTES_ROUTE_PREFIX}/details/${id}`;

      if (!tab) {
        return url;
      }

      return `${url}/${tab}`;
    },
    relativePath: 'booking-quotes/details/:id/:tab?'
  },
  index: {
    path: `${BOOKING_QUOTES_ROUTE_PREFIX}/:scope?`,
    getUrl: (scopeSlug?: string): string => {
      if (!scopeSlug) {
        return BOOKING_QUOTES_ROUTE_PREFIX;
      }

      return `${BOOKING_QUOTES_ROUTE_PREFIX}/${scopeSlug}`;
    },
    relativePath: 'booking-quotes/:scope?'
  }
};

export default bookingQuotesRoutes;
